import { LOGOUT } from '../constants/actionTypes';

const logout = () => {
  return {
    type: LOGOUT,
  };
};

export default logout;
